(function () {
  function init() {
    var els = Array.from(document.querySelectorAll('.section-sticky'));
    if (!els.length) return;

    var data = els.map(function (el, i) {
      var comp = getComputedStyle(el).position;
      return {
        el:        el,
        origPos:   comp === 'static' ? 'relative' : comp,
        origTop:   0,
        height:    0,
        z:         1 + i,
        spacer:    null,
        overlay:   null,
        isFixed:   false,
        isCovered: false
      };
    });

    // Later sections always visually on top
    data.forEach(function (d) {
      d.el.style.position = d.origPos;
      d.el.style.zIndex   = d.z;
    });

    // Spacer holds layout space while section is position:fixed
    data.forEach(function (d) {
      var sp = document.createElement('div');
      sp.style.cssText = 'display:none;pointer-events:none;';
      d.el.parentNode.insertBefore(sp, d.el);
      d.spacer = sp;
    });

    // Black overlay div — fades IN as next section scrolls over this one
    data.forEach(function (d, i) {
      if (i < data.length - 1) {
        var ov = document.createElement('div');
        ov.style.cssText = [
          'display:block',
          'position:absolute',
          'inset:0',
          'background:#000',
          'opacity:0',
          'pointer-events:none',
          'z-index:9999'
        ].join(';');
        d.el.appendChild(ov);
        d.overlay = ov;
      }
    });

    function measure() {
      data.forEach(function (d) {
        if (!d.isFixed) {
          d.origTop = d.el.getBoundingClientRect().top + window.pageYOffset;
          d.el.dataset.stickyOrigTop = d.origTop;
          d.height  = d.el.offsetHeight;
          d.spacer.style.height = d.height + 'px';
        }
      });
    }

    function restore(d) {
      d.el.style.position      = d.origPos;
      d.el.style.top           = '';
      d.el.style.left          = '';
      d.el.style.right         = '';
      d.el.style.zIndex        = d.z;
      d.el.style.pointerEvents = '';
      d.el.style.willChange    = '';
      d.spacer.style.display   = 'none';
      if (d.overlay) d.overlay.style.opacity = '0';
      d.isFixed = false;
    }

    function pin(d) {
      d.el.style.position    = 'fixed';
      d.el.style.left        = '0';
      d.el.style.right       = '0';
      d.el.style.zIndex      = d.z;
      d.el.style.willChange  = 'top';
      d.spacer.style.display = 'block';
      d.isFixed = true;
    }

    var raf = null;
    function tick() {
      raf = null;
      var scrollY = window.pageYOffset;

      data.forEach(function (d, i) {
        var el   = d.el;
        var next = data[i + 1];

        // ── Last sticky section: never pin ─────────────────────────────
        if (!next) {
          if (d.isFixed) restore(d);
          return;
        }

        // distanceToTop > 0 means element hasn't reached viewport top yet
        var distanceToTop = d.origTop - scrollY;

        // ── Zone 1: far from viewport top ──────────────────────────────
        if (distanceToTop > 80) {
          d.isCovered = false;
          el.style.pointerEvents = '';
          if (d.overlay) d.overlay.style.opacity = '0';
          if (d.isFixed) restore(d);
          return;
        }

        // ── Reverse-scroll: reset isCovered when next section drops back ─
        if (d.isCovered && next.el.getBoundingClientRect().top > 0) {
          d.isCovered = false;
        }

        // Stay restored if already fully covered
        if (d.isCovered) {
          if (d.isFixed) restore(d);
          return;
        }

        // ── Zone 2: pin + smooth top (no jump) ─────────────────────────
        // Pin early (within 80px) so top starts at the element's natural
        // position and slides smoothly to 0 — eliminates jerk completely.
        if (!d.isFixed) pin(d);
        el.style.top = Math.max(0, distanceToTop) + 'px';

        // ── Black overlay fades IN as next section scrolls over ─────────
        var nextTop   = next.el.getBoundingClientRect().top;
        var fadeRange = Math.min(d.height, window.innerHeight);

        if (nextTop <= 0) {
          d.isCovered = true;
          if (d.overlay) d.overlay.style.opacity = '0';
          if (d.isFixed) restore(d);
        } else if (nextTop < fadeRange) {
          var progress = 1 - nextTop / fadeRange;
          if (d.overlay) d.overlay.style.opacity = progress.toFixed(3);
        } else {
          if (d.overlay) d.overlay.style.opacity = '0';
        }
      });
    }

    function onScroll() {
      if (!raf) raf = requestAnimationFrame(tick);
    }

    measure();
    tick();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); tick(); });
    window.addEventListener('load',   function () { measure(); tick(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
